export const ONE_DAY_MILLISECONDS = 1000 * 60 * 60 * 24;
export const BUTTON_THROTTLE_DELAY = 500;
export const MONTH_INDEX_SHIFT = 1;
export const FIRST_MONTH_INDEX = 0;
export const LAST_MONTH_INDEX = 11;
export const FIRST_DATE_IN_MONTH = 1;
export const LAST_DATE_IN_MONTH = 31;
export const ONE_DAY = 1;
